import { Component, type ReactNode } from 'react';
import { Alert, Button, Stack, Text } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  message: string;
}

export class CustomerErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: '' };

  static getDerivedStateFromError(error: unknown): State {
    return {
      hasError: true,
      message: error instanceof Error ? error.message : 'Unbekannter Fehler',
    };
  }

  reset = () => this.setState({ hasError: false, message: '' });

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <Stack align="center" py="xl">
          <Alert
            icon={<IconAlertCircle size={18} />}
            color="red"
            radius="md"
            maw={480}
            w="100%"
            title="Fehler beim Laden"
          >
            <Text size="sm" mb="sm">{this.state.message}</Text>
            <Button size="xs" variant="light" color="red" onClick={this.reset}>
              Erneut versuchen
            </Button>
          </Alert>
        </Stack>
      );
    }
    return this.props.children;
  }
}
